import { useEffect } from 'react'

export function useOnMount(cb: () => void | (() => void | undefined)) {
    // eslint-disable-next-line react-hooks/exhaustive-deps,no-void
    return void useEffect(cb, [])
}
